<template>
    <div class="mt-4">
        <div
            v-if="$slots.default"
            class="text-sm font-semibold text-gray-800 mb-2"
        >
            <slot />
        </div>

        <input 
            v-model="skill"
            :placeholder="props.placeholder"
            type="text"
            @keyup.enter="handleAddSkill"
            :class="[
                inputStyle,
            ]"
            @blur="emit('input:blur')"
        />

        <div
            v-if="$slots?.subtitle"
            class="mt-0.5"
        >
            <slot name="subtitle" />
        </div>

        <div class="flex flex-row flex-wrap justify-start gap-x-2">
            <div classs="flex justify-between items-center  mt-1 flex-nowrap bg-[#F2FAFF] rounded-lg block px-[6px] py-[1px]" v-for="skill in skills" :key="skill">
                <span class="font-[Inter] italic text-xs text-[#073B5D] font-normal inline-block">{{ skill }}</span>
                
                <span class="cursor-pointer inline-block pl-1" @click="() => handleDelete(skill)">
                    <img class="h-3" src="/img/close.png" />
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { inputStyle } from "../../utils/styles";

const props = defineProps({
    placeholder: String,
    modelValue: {
        type: Array,
        default: []
    },
})

const skill = ref(null)
const skills = ref([])

const emit = defineEmits(['update:modelValue', 'input:blur']);

const handleAddSkill = () => {
    if(! skill.value) return
    if(skills.value.find(el => el == skill.value)) return

    skills.value.push(skill.value)
    skill.value = ''

    handleChange(skills.value)
}

const handleDelete = (skill) => {
    skills.value = skills.value.filter(el => el != skill)
    handleChange(skills.value)
}

const handleChange = (val) => {
    emit("update:modelValue", val);
}

</script>
